/**
 * NOTE: These are used to store various schedules for using
 * accross Web and Mobile applications.
 */
enum Schedules {
  CONTACT_HOURS = "Mon - Fri 5am - 5pm PT",
}

export default Schedules

